import React from 'react';
import { componentService } from 'js/services/component.service';

export const CookieSettings = React.lazy(() => import(/* webpackChunkName: "cookie-settings" */ './CookieSettings'));

// <hub2-cookie-settings></hub2-cookie-settings>
componentService.registerWebContentComponents({ CookieSettings });
